import React, { Component } from "react";
import { connect } from "react-redux";

import { setLauncherInstalled } from "../actions/launcherActions";

class ActivateLauncher extends Component {
	constructor(props) {
		super(props);
		this.state = {
			tokensSentToLauncher: false,
		};
	}
	componentDidMount() {
		console.log("ActivateLauncher called");
		this.props.setLauncherInstalled(true);
	}

	render() {
		return <div>{`You're all set up with the LexWorkplace Launcher!`}</div>;
	}
}
const mapStateToProps = () => ({});
export default connect(mapStateToProps, {
	setLauncherInstalled,
})(ActivateLauncher);
